/* @flow */
// typecheck: ignore file
import { Container } from 'flux/utils';
import React, { Component } from 'react';
import CurrentUser from 'auth/CurrentUser';
import User from 'entities/User';
import AppLayout from 'app/components/AppLayout.jsx';

type State = {
  user: ?User,
};

class AppLayoutContainer extends Component {
  state: State;

  static getStores() {
    return [CurrentUser];
  }

  static calculateState(): State {
    return {
      user: CurrentUser.getUser(),
    };
  }

  render() {
    return <AppLayout user={this.state.user} {...this.props} />;
  }
}

export { AppLayoutContainer };
export default Container.create(AppLayoutContainer, { withProps: true });



// WEBPACK FOOTER //
// ./src/app/containers/AppLayoutContainer.jsx